import React from "react";
import HeaderComponent from "../HeaderComponent/HeaderComponent";
import { serviceData } from "../../fifthUtils/constant";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const HomeService = (props) => {
    const { selectedLanguage, language } = props;
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const history = useHistory()
    return (
        <div className="fifth-des-home-service-main">
            <HeaderComponent title={selectedLanguage?.our_services_heading} lineClass='bg-White' titleClass='color-white' />
            <div className="fifth-des-home-service">
                {
                    serviceData?.map((v, i) => {
                        return (
                            <div>
                                <img src={v?.img} alt="" onClick={() => history?.push(v?.link)} />
                                <h2>
                                    {isELSelect ? v?.title : (isAlSelect ? v?.alTitle : v?.glTitle)}
                                </h2>
                                <p>
                                    {isELSelect ? v?.text : (isAlSelect ? v?.alText : v?.glText)}
                                </p>
                                <button onClick={() => history?.push(v?.link)}>
                                    {selectedLanguage?.txt_more}
                                </button>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
export default HomeService